// Electron shell only: the shell sends app URLs that the page asked to open in a
// new tab, and the page shows them in the same window with the SPA router.

export function navigateInApp(url, router, location = window.location) {
  let target
  try {
    target = new URL(url, location.href)
  } catch (error) {
    location.assign(url)
    return
  }
  const path = target.pathname + target.search + target.hash
  if (router.resolve(path).route.matched.length > 0) {
    // vue-router 3.0.3: push returns undefined and aborts a duplicate navigation silently.
    router.push(path)
  } else {
    location.assign(url)
  }
}

// Registers the listener only in the Electron app and only when the installed
// shell supports it. Returns true when the listener is registered.
export function registerElectronNavigation(isElectron, router, electronAPI = window.electronAPI) {
  if (!isElectron || !electronAPI || typeof electronAPI.onNavigateInApp !== 'function') {
    return false
  }
  electronAPI.onNavigateInApp((url) => navigateInApp(url, router))
  return true
}
